export default __webpack_public_path__ + "static/about-us-sustainability-18e83a08061a8917b26b9bcb458ff579.jpg";